interface SevenSegmentDisplayProps {
	number: number;
}

const segments: Record<number, number[]> = {
	0: [1, 1, 1, 1, 1, 1, 0],
	1: [0, 1, 1, 0, 0, 0, 0],
	2: [1, 1, 0, 1, 1, 0, 1],
	3: [1, 1, 1, 1, 0, 0, 1],
	4: [0, 1, 1, 0, 0, 1, 1],
	5: [1, 0, 1, 1, 0, 1, 1],
	6: [1, 0, 1, 1, 1, 1, 1],
	7: [1, 1, 1, 0, 0, 0, 0],
	8: [1, 1, 1, 1, 1, 1, 1],
	9: [1, 1, 1, 1, 0, 1, 1],
	14: [1, 0, 0, 1, 1, 1, 1],
	15: [1, 0, 0, 0, 1, 1, 1],
};

const SevenSegmentDisplay = ({ number }: SevenSegmentDisplayProps) => {
	const activeSegments = segments[number] || segments[0];

	// Dimensões base do viewBox
	const svgWidth = 90;
	const svgHeight = 120;

	// Calcula os pontos de cada segmento proporcionalmente
	const seg0 = `0,0 ${svgWidth},0 ${0.8 * svgWidth},${0.1 * svgHeight} ${0.2 * svgWidth},${0.1 * svgHeight}`;
	const seg1 = `${svgWidth},0 ${svgWidth},${0.45 * svgHeight} ${0.9 * svgWidth},${0.5 * svgHeight} ${0.8 * svgWidth},${0.45 * svgHeight} ${0.8 * svgWidth},${0.1 * svgHeight}`;
	const seg2 = `${0.9 * svgWidth},${0.5 * svgHeight} ${svgWidth},${0.55 * svgHeight} ${svgWidth},${svgHeight} ${0.8 * svgWidth},${0.9 * svgHeight} ${0.8 * svgWidth},${0.55 * svgHeight}`;
	const seg3 = `${svgWidth},${svgHeight} 0,${svgHeight} ${0.2 * svgWidth},${0.9 * svgHeight} ${0.8 * svgWidth},${0.9 * svgHeight}`;
	const seg4 = `${0.1 * svgWidth},${0.5 * svgHeight} ${0.2 * svgWidth},${0.55 * svgHeight} ${0.2 * svgWidth},${0.9 * svgHeight} 0,${svgHeight} 0,${0.55 * svgHeight}`;
	const seg5 = `0,0 ${0.2 * svgWidth},${0.1 * svgHeight} ${0.2 * svgWidth},${0.45 * svgHeight} ${0.1 * svgWidth},${0.5 * svgHeight} 0,${0.45 * svgHeight}`;
	const seg6 = `${0.1 * svgWidth},${0.5 * svgHeight} ${0.2 * svgWidth},${0.45 * svgHeight} ${0.8 * svgWidth},${0.45 * svgHeight} ${0.9 * svgWidth},${0.5 * svgHeight} ${0.8 * svgWidth},${0.55 * svgHeight} ${0.2 * svgWidth},${0.55 * svgHeight}`;

	return (
		<svg
			width={`${svgWidth}`}
			height={`${svgHeight}`}
			viewBox={`0 0 ${svgWidth} ${svgHeight}`}
			className="mx-auto my-4 px-2 bg-gray-900 border-8 border-gray-400"
		>
			<polygon
				className={`segment ${activeSegments[0] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg0}
			/>
			<polygon
				className={`segment ${activeSegments[1] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg1}
			/>
			<polygon
				className={`segment ${activeSegments[2] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg2}
			/>
			<polygon
				className={`segment ${activeSegments[3] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg3}
			/>
			<polygon
				className={`segment ${activeSegments[4] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg4}
			/>
			<polygon
				className={`segment ${activeSegments[5] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg5}
			/>
			<polygon
				className={`segment ${activeSegments[6] ? "fill-red-500" : "fill-gray-700"}`}
				points={seg6}
			/>
		</svg>
	);
};

export default SevenSegmentDisplay;
